import type { AppliedLesson } from '@/models/appliedlesson';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';

export const enum ResolvedEnum {
    'Resolved' = 'resolved',
    'NotResolved' = 'not_resolved',
    'All' = 'all',
}

export const filterAppliedLessonsResolved = <T extends AppliedLesson | XAppliedLesson | PMAppliedLesson>(
    appliedLesson: T,
    resolved: ResolvedEnum
) => {
    switch (resolved) {
        case ResolvedEnum.All:
            return true;
        case ResolvedEnum.Resolved:
            return appliedLesson.done;
        case ResolvedEnum.NotResolved:
            return !appliedLesson.done;
    }
};
